// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$FileList = require("../../common/Components/FileList.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardRelayPreviewFiles_previewHelpers_graphql = require("../../../__generated__/PropertyWizardRelayPreviewFiles_previewHelpers_graphql.bs.js");

var convertFragment = PropertyWizardRelayPreviewFiles_previewHelpers_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewFiles_previewHelpers_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewFiles_previewHelpers_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewFiles_previewHelpers_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewFiles_previewHelpers_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__Preview__Files(props) {
  var displayHelpers = use(props.displayHelpers);
  var files = displayHelpers.files;
  var files$1 = files !== undefined ? files.map(function (f) {
          return f.fragmentRefs;
        }) : [];
  return JsxRuntime.jsx($$FileList.make, {
              files: files$1
            });
}

var make = PropertyWizardRelay__Preview__Files;

exports.Fragment = Fragment;
exports.make = make;
/* FileList Not a pure module */
